import { Size } from '@react-three/fiber';
import { Mesh, PerspectiveCamera, Texture } from 'three';

import { textureImage } from 'utils/textureImage';

export const getFullScreenSize = (
  camera: PerspectiveCamera,
  sceneSize: Size,
  meshPositionZ: number
) => {
  const perspectiveCamera = camera as PerspectiveCamera;
  const verticalFOV = (perspectiveCamera.fov * Math.PI) / 180;

  const aspect = sceneSize.width / sceneSize.height;
  const distance = Math.abs(camera.position.z - meshPositionZ);
  const height = 2 * Math.tan(verticalFOV / 2) * distance;
  const width = height * aspect;

  return { width, height };
};

export const WEATHER_SCREEN_PREFIX = 'weather_';

interface scaleBackgroundProps {
  mesh: Mesh;
  camera: PerspectiveCamera;
  size: Size;
  positionZ: number;
  texture: Texture;
}

export const scaleBackground = (props: scaleBackgroundProps) => {
  const { height, width } = getFullScreenSize(
    props.camera as PerspectiveCamera,
    props.size,
    props.positionZ
  );

  const { width: textureWidth, height: textureHeight } = textureImage(
    props.texture
  );

  // A texture that has not finished decoding reports no dimensions, and the
  // ratio below would come out NaN and collapse the plane.
  if (!textureWidth || !textureHeight) return;

  const textureRatio = textureWidth / textureHeight;
  const screenRatio = width / height;

  // object-fit: cover — match the axis that would otherwise leave a gap and
  // let the other one overflow.
  if (screenRatio > textureRatio) {
    props.mesh.scale.set(width, width / textureRatio, 1);
  } else {
    props.mesh.scale.set(height * textureRatio, height, 1);
  }

  // useMatrixUpdateHandler turns matrixAutoUpdate off across the weather
  // subtree once it is rendered. From that point three stops composing
  // position/rotation/scale into the matrix on its own, so the scale set above
  // would never reach the screen and the plane would keep whatever size its
  // matrix was frozen at.
  props.mesh.updateMatrix();
};
